import { useEffect } from "react";
import { useGetSettings } from "@/settings/api/queries/settings.queries.ts";
import { useTimezoneStore } from "@/shared/stores/useTimezoneStore.ts";

/**
 * Publishes every location's configured IANA timezone from `/api/settings/`
 * into {@link useTimezoneStore}, which is what all time DISPLAY resolves
 * against.
 *
 * Organization scope returns ALL locations in one response, so mount this ONCE
 * high in the tree (the dashboard layout) — never per page.
 */
export const useLocationTimezoneSync = (): void => {
  const { data } = useGetSettings({ scope: "organization" });
  const setLocationTimezones = useTimezoneStore((s) => s.setLocationTimezones);

  useEffect(() => {
    const locations = data?.data.data.locations;
    if (!locations) return;
    setLocationTimezones(
      Object.fromEntries(locations.map((location) => [location.id, location.timezone ?? null])),
    );
  }, [data, setLocationTimezones]);
};
